module.exports = __webpack_public_path__ + "e496dab47aa875e73f009bfa527beb2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_8.jpg
// module id = 1790
// module chunks = 5